export const DEFAULT_PROFILE = {
    name: "Guest",
    en_name: "",
    zh_name: "",
    description: "",
    avatar_url: "",
    public_key: "",
    social_connections: [],
};
//# sourceMappingURL=const.js.map